import React, { useContext, useEffect } from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Paper from '@material-ui/core/Paper';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import AnimatedNumber from 'react-animated-number';

import { IEventItem } from '../../../../store/player/events/store';

import Button from '../../../../components/Button';
import CardHeader from '../../../../components/CardHeader';
import { ICheckoutState } from '../EventCheckout/EventCheckout';
import { GlobalContext } from '../../../../store';
import { useRouteInfoState } from '../../../../components/RouteInfo/Context/RouteInfo.context';
import { formatTotal } from '../../../common/Utils/formatTotal';

interface IProps {
  item: IEventItem;
  checkoutState: ICheckoutState;
  onContinue: () => void;
  onCancel: () => void;
  onPrevious: () => void;
  onCouponCheck: (checkout: ICheckoutState, code: string) => Promise<any>;
}

const EventConfirm = (props: IProps) => {
  const { item, onContinue, onCancel, onPrevious, onCouponCheck } = props;

  const {
    actions: {
      events: { getRegistrationSummary }
    },
    eventRegistration
  } = useContext(GlobalContext);

  const { eventId } = useRouteInfoState();

  const {
    coupon: { title: couponTitle, discountValue: couponValue }
  } = eventRegistration as any;

  const total = eventRegistration.totalPrice;
  const price = eventRegistration.items.eventPrice;
  const activeAddons = eventRegistration.items.addons;
  const pendingMembership = eventRegistration.items.clubMembershipPrice || 0;

  useEffect(() => {
    if (eventId) {
      getRegistrationSummary(Number(eventId), []).catch();
    }

    onCouponCheck({ selectedAddons: {} }, '').catch();
  }, [eventId]);

  return (
    <div className="event-checkout wrapper">
      <Paper elevation={1} className="paper">
        {item && item.processPayment ? (
          <>
            <CardHeader label="Checkout" backTo={onPrevious} />

            <div className="pricing-table">
              <div className="th">
                <div>ENTRY FEES</div>
              </div>

              {Number(pendingMembership) > 0 && (
                <div className="tr">
                  <div>Club Membership</div>

                  <div>${Number(pendingMembership).toFixed(2)}</div>
                </div>
              )}

              <div className="tr">
                <div>{price.name}</div>

                <div>${price.price}</div>
              </div>
            </div>

            {activeAddons.length > 0 && (
              <div className="pricing-table">
                <div className="th">
                  <div>EVENT EXTRAS</div>
                </div>

                {activeAddons.map(addon => (
                  <FormGroup
                    row={true}
                    className="input checkbox"
                    key={`addon-wrapper-${addon.id}`}
                  >
                    <FormControlLabel
                      className="checkout-checkbox"
                      control={
                        <Checkbox
                          id={`addon-${addon.id}`}
                          checked={true}
                          icon={<CheckBoxOutlineBlankIcon color="primary" />}
                          checkedIcon={<CheckBoxIcon />}
                          value="on"
                          color="primary"
                        />
                      }
                      label={addon.name}
                    />
                    <div className="fee">${Number(addon.price).toFixed(2)}</div>
                  </FormGroup>
                ))}
              </div>
            )}

            <div className="coupon-picker">
              {couponTitle && (
                <div className={'chip active'}>
                  <Chip
                    label={couponTitle}
                    className="chip-item"
                    color="primary"
                    variant="outlined"
                  />

                  <div className="coupon-value">${couponValue}</div>
                </div>
              )}
            </div>

            <div className="total">
              <div>Total</div>

              <AnimatedNumber
                component="div"
                stepPrecision={2}
                value={total}
                style={{
                  transition: '0.8s ease-out',
                  transitionProperty: 'background-color, color, opacity'
                }}
                duration={300}
                formatValue={formatTotal}
              />
            </div>

            <Button
              id="checkout-continue"
              variant="contained"
              color="primary"
              className="button button-shadow"
              onClick={onContinue}
            >
              PAY ENTRY FEES
            </Button>

            <Button
              variant="outlined"
              color="primary"
              className="button"
              onClick={onCancel}
              id="checkout-cancel"
            >
              DECLINE INVITATION
            </Button>
          </>
        ) : (
          <>
            <h4>Confirmation</h4>

            <Button
              id="checkout-continue"
              variant="contained"
              color="primary"
              className="button button-shadow"
              onClick={onContinue}
            >
              ACCEPT INVITATION
            </Button>

            <Button
              variant="outlined"
              color="primary"
              className="button"
              onClick={onCancel}
              id="checkout-cancel"
            >
              DECLINE INVITATION
            </Button>
          </>
        )}
      </Paper>
    </div>
  );
};

export default EventConfirm;
